/** Text sizing mirrored from DrawMapUtil.placeText / chooseSize */

export const TEXT_INDENT = 20 + 7 * 2; // INDENT = 20 + DRAW_EDGE_INDENT * 2
export const TEXT_FONT_START = 50;
export const TEXT_FONT_DELTA = 1;
/** Canvas 2D and troika glyph advances differ slightly. */
export const TEXT_WIDTH_SAFETY = 1.08;

let measureCtx;

function getMeasureContext() {
    if (typeof document === 'undefined') {
        return null;
    }
    if (!measureCtx) {
        const canvas = document.createElement('canvas');
        measureCtx = canvas.getContext('2d');
    }
    return measureCtx;
}

/** Approximate width when Canvas 2D is unavailable (SSR / tests). */
function estimateWidth(text, fontSize) {
    // Calibri/DejaVu sans average advance ~0.52em for mixed Latin+digits
    return text.length * fontSize * 0.52;
}

/**
 * Measure string width at fontSize (Java uses Font stringBounds width).
 * Java getMetric(HEIGHT) also returns width — we mirror that in chooseFontSize.
 */
export function measureTextWidth(text, fontSize) {
    const ctx = getMeasureContext();
    if (!ctx) {
        return estimateWidth(text, fontSize);
    }
    // Prefer Calibri like Java; fall back to DejaVu used by the Python reference
    ctx.font = `${fontSize}px Calibri, "DejaVu Sans", Arial, sans-serif`;
    return ctx.measureText(text).width;
}

function measureTextHeight(text, fontSize) {
    const ctx = getMeasureContext();
    if (!ctx) {
        return fontSize * 1.15;
    }
    ctx.font = `${fontSize}px Calibri, "DejaVu Sans", Arial, sans-serif`;
    const metrics = ctx.measureText(text);
    const boundsHeight = (metrics.actualBoundingBoxAscent || 0) + (metrics.actualBoundingBoxDescent || 0);
    return Math.max(boundsHeight, fontSize * 1.15);
}

/**
 * Shrink from TEXT_FONT_START until the text's actual width and height fit the detail.
 * @param {string} text
 * @param {number} aRect dimension along text before rotation
 * @param {number} bRect dimension across text before rotation
 */
export function chooseFontSize(text, aRect, bRect) {
    let size = TEXT_FONT_START;
    while (size > 1) {
        const textWidth = measureTextWidth(text, size);
        const weightFont = textWidth * TEXT_WIDTH_SAFETY + TEXT_INDENT;
        const heightFont = measureTextHeight(text, size) + TEXT_INDENT;
        if (weightFont <= aRect && bRect >= heightFont) {
            return size;
        }
        size -= TEXT_FONT_DELTA;
    }
    return 1;
}

/**
 * Font size and orientation for a label inside a rectangle (Java placeText).
 */
export function fitLabelInRect(text, rectWidth, rectHeight) {
    const rotate = rectWidth < rectHeight;
    const fontSize = rotate
        ? chooseFontSize(text, rectHeight, rectWidth)
        : chooseFontSize(text, rectWidth, rectHeight);
    return {fontSize, rotate};
}
